import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

const useActionSnackBar = (i18nKey) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const snackBar = (message, variant, durationInMs = 2000) => {
    return enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
      autoHideDuration: durationInMs,
    });
  };

  const actionSnackBar = (action, status, extraParams) => {
    if (!action || !status) return;
    switch (status) {
      case "success":
        return snackBar(t(`${i18nKey}toast.${action}Success`, extraParams), "success");
      case "failed":
        return snackBar(t(`${i18nKey}toast.${action}Failed`, extraParams), "error");
      case "info":
        return snackBar(t(`${i18nKey}toast.${action}Info`, extraParams), "info");
      default:
        return;
    }
  };

  return { actionSnackBar, snackBar };
};

export default useActionSnackBar;
